import React, { useEffect } from 'react';
import { RefObject, useCallback } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import { headerItems, headerPictures } from '~/src/features/videocontrol/data';

import * as ST from './styled';

export interface IHeaderProps {
    videocontrolRef?: RefObject<HTMLHeadingElement | null>,
}

const Header = ({ videocontrolRef }: IHeaderProps): JSX.Element => {

  let slideIndex = 0;

  function showSlides() {
    let i;
    const slides = document.getElementsByClassName('mySlides') as HTMLCollectionOf<HTMLElement>;
    if (slides.length) {
      for (i = 0; i < slides.length; i++) {
        slides[i].style.opacity = '0';
      }
      slideIndex++;
      if (slideIndex > slides.length) {
        slideIndex = 1;
      }
      slides[slideIndex - 1].style.opacity = '1';
      setTimeout(showSlides, 4000);
    }
    clearTimeout(undefined);
  }

  useEffect(() => {
    showSlides();
  }, []);

  const handleClick = useCallback(() => {
    dataLayerPush({
      event: EVENTS.UAevent,
      category: CATEGORIES.landing,
      action: ACTIONS.clickOnBtn,
      label: 'first screen',
    });
    videocontrolRef?.current?.scrollIntoView({
      behavior: 'smooth',
    });
  }, [videocontrolRef]);

  return (
    <ST.Wrapper>
      <ST.Container>
        <ST.TextContainer>
          <ST.SubTitle>Не беспокойтесь, всë под присмотром!</ST.SubTitle>
          <ST.Title>Умная система видеонаблюдения</ST.Title>
          <ST.ItemsBlock>
            {headerItems.map(({ icon, text }, index) => <ST.Item key={`main-item-${index}`}>
              <ST.IconBlock>
                {icon && <img src={icon} alt={text}/>}
              </ST.IconBlock>
              <ST.Text
                // @ts-ignore
                dangerouslySetInnerHTML={{ __html: text }}
              />
            </ST.Item>)
            }
          </ST.ItemsBlock>
          <ST.Button onClick={handleClick} type={btnTypes.ACCENT}>Подключить</ST.Button>
        </ST.TextContainer>
        <ST.ImageContainer data-test='header-image'>
          <ST.Picture className='mySlides'>
            <WebpImage urlWebp={headerPictures[0].webp}>
              <ST.ImgStyled
                src={headerPictures[0].png}
                alt={headerPictures[0].text}
              />
            </WebpImage>
          </ST.Picture>
          <ST.Picture className='mySlides'>
            <WebpImage urlWebp={headerPictures[1].webp}>
              <ST.ImgStyled
                src={headerPictures[1].png}
                alt={headerPictures[1].text}
              />
            </WebpImage>
          </ST.Picture>
          <ST.Picture className='mySlides'>
            <WebpImage urlWebp={headerPictures[2].webp}>
              <ST.ImgStyled
                src={headerPictures[2].png}
                alt={headerPictures[2].text}
              />
            </WebpImage>
          </ST.Picture>
        </ST.ImageContainer>
      </ST.Container>
    </ST.Wrapper>
  );
};

export default Header;
